import { MDBAlert, MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { editUser } from "../../../apiclients/streamsapi_bridge";
import { validatePhoneNumber } from "../phonenumbers/AddRemoveNumbers";
const AddExternalNumbr = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [existNumber, setExistNumber] = useState([]);
    const [newNumber, setNewNumber] = useState({});
    const [editexternal, setEditExternal] = useState([]);
    const [internalError, setInternalError] = useState(false);
    const { register, handleSubmit, formState, setValue, setError, reset } = useForm({
        defaultValues: {
            title: "",
            phNum: "",
        }
    });
    const { errors, isDirty } = formState;

    useEffect(() => {
        if (props) {
            setExistNumber(props.existexternalNumbers);
            setEditExternal(props.finalEditExternal);

        }

    }, [props])

    const onsubmit = async (data) => {
        let errorFlag = false;
        if (isDirty) {
            existNumber.some((item) => {
                if (item.title === data.title) {
                    setError("title", { message: "Name should not be duplicate" });
                    errorFlag = true;
                }
                if (parseInt(item.phNum) === parseInt(data.number)) {
                    setError("phNum", { message: "Phone number should not be duplicate" });
                    errorFlag = true;
                }
            });

            if (!errorFlag) {
                props.setIsloading(true);
                let updates = {};
                updates = {
                    reqid: 3,
                    siteid: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid,
                    agentid: props.useragent,
                    external_phnum: {
                        create_phnum: {
                            title: data.title,
                            phNum: parseInt(data.phNum),
                            callRouteFlag: 1
                        }

                    }
                }
                console.log("Add External nuumber  :::::::: " + JSON.stringify(updates));

                let saverep = await editUser(updates);
                props.setIsloading(false);
                console.log(saverep);
                let saverepeMsg = await saverep.json();
                //alert(JSON.stringify(saverepeMsg));

                if (saverepeMsg.status && saverepeMsg.status == "success") {
                    const extid = saverepeMsg?.externalNumInsertId[0] ?? [];
                    const externalid = extid?.externalNumId ?? 0
                    // alert(externalid);
                    props.setSuccessMessage(`External Number ${data.phNum} added successfully.`);
                    props.setIsExternalModify(true);
                    props.setaddExternalFlag(true);
                    props.setNewExternalNum({
                        title: data.title,
                        phNumber: parseInt(data.phNum),
                        id: parseInt(externalid)

                    })
                    props.onClose();

                } else {

                    if (saverepeMsg.message?.errors) {
                        if (
                            saverepeMsg.message?.errors[0].errors &&
                            saverepeMsg.message?.errors[0].errors.length > 0
                        ) {
                            saverepeMsg.message?.errors[0].errors.forEach((err) => {
                                if (err.param_name === "logined_user") {
                                    props.setErrorMessage(err.message);
                                    reset();
                                }
                                let errorMsg = err.message, key = (err.param_name).substring(err.param_name.lastIndexOf('.') + 1);
                                setError(key, {
                                    type: "server",
                                    message: errorMsg,
                                });
                                const fieldElement = document.querySelector(
                                    `input[name="${key}"]`
                                );
                                if (fieldElement) {
                                    fieldElement.focus();

                                }
                            });
                        }

                    } else {
                        setInternalError(true);
                    }

                }

            }


        }

    }

    return (
        <>
            <form>
                <div>
                    <div className="tel-numbers">
                        <strong>{t("ExtNumberName")}</strong>
                    </div>
                    <div className="form pt-1">
                        <input
                            maxLength={30}
                            type="text"
                            className="form-control"
                            {...register("title", { required: "External Number Name should not be empty" })}

                        />
                        {errors.title && (
                            <p className="text-danger">{errors.title.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-1">
                        <strong>{t("Number")}</strong>
                    </div>
                    <div className="form pt-1">
                        <input
                            type="text"
                            className="form-control"
                            {...register("phNum", { required: "Number should not be empty", validate: validatePhoneNumber, })}
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                        />
                        {errors.phNum && (
                            <p className="text-danger">{errors.phNum.message}</p>
                        )}
                    </div>
                </div>

                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                        {t("add")}</button>
                </div>

                {/* <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                        {t("cancel")}
                    </MDBBtn>
                    <MDBBtn onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(onsubmit)();
                    }}>{t("add")}</MDBBtn>
                </MDBModalFooter> */}
            </form>

            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}
        </>
    )
});
export default AddExternalNumbr;